import { render, staticRenderFns } from "./TieredPricing.vue?vue&type=template&id=1e1a205d&"
import script from "./TieredPricing.vue?vue&type=script&lang=js&"
export * from "./TieredPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports